import holidays from 'date-holidays';
import dayjs from 'dayjs';

export const getCalendarMonthMatrix = (
    // ! Customizing Calendar Language was done here, fix it later to french in order to display days name on french inside the calendar
    // monthCra = dayjs.locale(fr).month;//month==decimal //? french local time
    { monthCra = dayjs().month(), yearCra = dayjs().year(),pays='fr' } = {} // * default current year and month
) => {
    //* monday = 0, sunday=6
    // ? rest of devision rule : 6%6 = 0 7%6 =1 ..
    // const firstDayOfTheMonth = dayjs(new Date(yearCra, monthCra, 1)).locale(fr).day();
    const firsDayOfTheMonth = dayjs(new Date(yearCra, monthCra, 0)).locale(pays).day();
    //const weekendOfTheMonth =
    let currentMonthCount = 1 - (firsDayOfTheMonth + 7 % 6);
    // console.log('getCalendarMonthMatrix',{monthCra, yearCra});
    const daysMatrix = new Array(5).fill([]).map(() => {
        return new Array(7).fill(null).map(() => {
            currentMonthCount++;
            return dayjs(new Date(yearCra, monthCra, currentMonthCount + firsDayOfTheMonth));
        });
    });
    return daysMatrix;
};

export const minutesDifferenceToDecimalHours = (startTime, endTime) => {
    // export const minutesBetweenTwoTimes =  (startTime, endTime) => {
    // * inputs should be like: startTime=11:23 endTime: 15:40
    //create date format
    if(startTime && endTime){
        var timeStart = new Date('01/01/2007 ' + startTime);
        var timeEnd = new Date('01/01/2007 ' + endTime);

        var msDifference = timeEnd - timeStart;
        if (msDifference < 0) {
            msDifference = 24 + msDifference;
        }
        let differenceInMinutes = Math.floor(msDifference / 1000 / 60);
        // console.log({differenceInMinutes,valuestart: startTime, valuestop: endTime, diffDate : timeStart - timeEnd});
        // ? reutn
        // minutesToDecimalHours

        return differenceInMinutes / 60; //90min => 1.5
    }
    else
        return 0;
};

export const getCountryHolidays = (pays) => {
    const hd = new holidays(pays);
    return hd.getHolidays();
};

export const calculateNbDaysOfAMonth = (month) => {
    console.log({ month, year: month['0'][0].$y, monthM: month['0'][0].$M + 1, calculateNbDaysOfAMonth: new Date(month['0'][0].$y, month['0'][0].$M + 1, 0).getDate() });
    // month should be a day js format (like we use in cra now)
    return new Date(month['0'][0].$y, month['0'][0].$M + 1, 0).getDate();
};

export function isHolidayOrWeekendOrNotStartedBdc({ day, dateDebutBDC, dateFinBDC, holidaysDuMoisDuCra }) {
    //* ENGLISH WAY
    if (day.format('dddd').toUpperCase() === 'SATURDAY' || day.format('dddd').toUpperCase() === 'SUNDAY' ||
        // Is a holiday
        holidaysDuMoisDuCra.indexOf(convertDayToDate(day)) !== -1 ||
        // BDC not started yet
        calculateDurationBetweenDatesISOFormat(dateDebutBDC, dayjs(day.format('YYYY-MM-DD')).toISOString()) < 0 ||
        calculateDurationBetweenDatesISOFormat(dateFinBDC, dayjs(day.format('YYYY-MM-DD')).toISOString()) > 0
    ) {
        return true;
    }
    // ! French WAY : 2 fix
    // if (day.format('dddd').toUpperCase() === 'SAMEDI' || day.format('dddd').toUpperCase() === 'DIMANCHE' || holidaysDuMoisDuCra.indexOf(createDate(day)) !== -1) {
    //     return true;
    // }
    return false;
}

//=======================convertir au format de jour approprié que nous adoptons ====
function convertDayToDate(day) {
    let D = day.$D;
    let M = day.$M + 1;
    const Y = day.$y;
    let date = '';
    date += D.toString().padStart(2, 0) + '-' + M.toString().padStart(2, 0) + '-' + Y.toString();
    return date;
}
export function calculateDurationBetweenDatesISOFormat(startDate, endDate) {
    //     //* v0 : counting all days [like age]
    //     // ? difference counting all days
    //     // const diffTime = Math.abs(endDate?._d - startDate?._d); was a moment format
    //     // ! I removed the ABSOLUTE value, we need to know this info
    //     // const diffTime = Math.abs(endDate - startDate);
    //     const diffTime = endDate - startDate;
    //     const finalResultinDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    //     // console.warn(finalResultinDays);
    //     return finalResultinDays ;
    // * v1
    //! the two dates must be in A ISO 8601 format [we are more clear now about required formats]
    // console.log(startDate,endDate);
    var d1 = new Date(startDate).setHours(13, 0, 0, 0);
    var d2 = new Date(endDate).setHours(13, 0, 0, 0);
    // TODO: ca doit pas calculer la duree avec les heures, mais juste les jours. si tjrs on a un probleme d'un jours de moins dans la date debut et fin bdc. (if this setHours doesn't fix the problem)
    return (d2 - d1) / (1000 * 3600 * 24);
}

const isHoliday = (date, holidays) => {
    // Check if the date is in the list of holidays
    const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    return holidays.includes(formattedDate);
};

export const getLastWorkingDayOfMonth = (year, month,pays) => {
    let holidays =getCountryHolidays(pays);
    // Get the last day of the month
    const lastDay = new Date(year, month, 0);

    // Set the date to the last day of the month
    let currentDate = new Date(lastDay);

    // Check if it's a Saturday (6) or Sunday (0), or a holiday, and move to the previous day
    while (currentDate.getDay() === 6 || currentDate.getDay() === 0 || isHoliday(currentDate, holidays)) {
        currentDate.setDate(currentDate.getDate() - 1);
    }

    return currentDate;

};
